// Third-party
import React from 'react';
import classNames from 'classnames';
import ContactPastille from './ContactPastille';
import AdvisorInfos from '@/types/advisor-infos';

interface Props {
  contact: AdvisorInfos;
}

const ContactAvatar = ({ contact }: Props) => {
  const hasImage = !!contact.imgUrl;

  return (
    <div className="contact-avatar" data-private data-dd-privacy="mask">
      {hasImage ? <img alt={contact.name} src={contact.imgUrl} /> : <ContactPastille contact={contact} />}
      <div className="online-status-wrap">
        <div className={classNames('online-status', { online: contact.isOnline })} />
      </div>
    </div>
  );
};

export default ContactAvatar;
